module.exports = "/assets/4b4ffbcf3b5786315e1227ac2cbad920.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cars/assets/logos/ZD.png
// module id = 765
// module chunks = 0